import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatTermModel } from 'src/app/model/cat-term.model';
import { CatTermService } from 'src/app/services/cat-term.service';

@Component({
  selector: 'app-modal-term',
  templateUrl: './modal-term.component.html',
  styleUrls: ['./modal-term.component.css']
})
export class ModalTermComponent implements OnInit {
  @Input() term: CatTermModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private termService: CatTermService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.term.iActiveId = this.term.iActiveId ? 0 : 1;
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar el número de meses del plazo.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      let userName = localStorage.getItem('com_userName');
      this.termService.save(userName, this.term)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El plazo se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el plazo.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar el plazo.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.term.vDescription || this.term.vDescription.trim() === '';
}
